<template>
    <o-card :title="$t('sandoz.bulk_delivery')">
        <div class="input-group row mb-3">
            <div class="input-group-prepend pt-2 col-lg-2">
                {{$t('sandoz.contract_type')}}
            </div>
            <div class="col-lg-2">
                <b-dropdown class="w-100" variant="outline-secondary" right toggle-class="filter-multi">
                    <template slot="button-content">
                        {{$t('sandoz.filter_by_contract_type')}}
                    </template>
                    <b-dropdown-text>
                        <b-form-checkbox-group v-model="contractType" :options="contractTypes" value-field="value"
                                               text-field="text" stacked>
                        </b-form-checkbox-group>
                    </b-dropdown-text>
                </b-dropdown>
            </div>
            <div v-if="contractType.length">
                <span class="btn btn-secondary">
                    {{contractType.toString()}}
                    <fa icon="times" @click="contractType = []"/>
                  </span>
            </div>
            <div class="col-lg-3">
                <b-form-input type="search" :placeholder="$t('sandoz.contract_no')" v-model="contractNo"
                              autocomplete="off" @keyup.enter="search(product, planned_date, group, distributor)">
                </b-form-input>
            </div>
        </div>
        <div class="input-group row mb-3">
            <div class="input-group-prepend pt-2 col-lg-2">
                {{$t('sandoz.search_by_product')}}
            </div>
            <div class="col-lg-2">
                <b-form-select value="reset" :options="type" value-field="value" text-field="text"
                               @change="filters">
                </b-form-select>
            </div>
            <div class="col-lg-2" v-if="productList.length">
                <b-form-select v-model="product" value="reset" :options="productList" value-field="id"
                               text-field="name_lang" @change="search">
                </b-form-select>
            </div>
            <div class="col-lg-1 text-center pt-2 text-uppercase" v-if="productList.length">{{$t('sandoz.or')}}</div>
            <div class="col-lg-2" v-if="productList.length">
                <b-form-select v-model="group" value="reset" :options="productGroups" value-field="value"
                               text-field="product_group" @change="search(null, null, $event)">
                </b-form-select>
            </div>
            <div class="col-lg-1 text-center pt-2 text-uppercase" v-if="productList.length">{{$t('sandoz.or')}}</div>
            <div class="col-lg-2" v-if="productList.length">
                <b-form-select v-model="distributor" value="reset" :options="productDistributors" value-field="value"
                               text-field="distributor"
                               @change="search(null, null, null, $event)">
                </b-form-select>
            </div>
        </div>
        <div class="input-group row mb-3">
            <div class="input-group-prepend pt-2 col-lg-2">
              {{$t('sandoz.adhoc_items')}}
            </div>
            <div class="col-lg-2">
                <b-form-select v-model="adHocItem" :value="false" :options="adhocFilter"
                               @change="search(product, planned_date, group, distributor, $event)">
                </b-form-select>
            </div>
        </div>
        <div class="input-group row">
            <div class="input-group-prepend pt-2 col-lg-2">
                {{$t('sandoz.search_by_planned_date')}}
            </div>
            <div class="col-lg-2">
                <b-form-select v-model="planned_date" value="reset" :options="dateList" value-field="date" text-field="planned_delivery"
                               @change="search(null, $event)">
                </b-form-select>
            </div>
        </div>
        <div class="table-responsive" v-if="deliveries.length">
            <table class="table">
                <thead>
                <tr>
                    <th>
                      <b-form-checkbox v-model="toggleDelivery"></b-form-checkbox>
                    </th>
                    <th>{{$t('sandoz.contract_no')}}</th>
                    <th>{{$t('sandoz.customer')}}</th>
                    <th v-if="product === 'reset'">{{$t('sandoz.product')}}</th>
                    <th>{{$t('sandoz.quantity')}}</th>
                    <th>{{$t('sandoz.planned_delivery')}}</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(delivery, index) in deliveries">
                    <td>
                        <b-form-checkbox v-model.lazy="bulkDelivery" :name="'delivery-'+delivery.id" :value="delivery.id">
                        </b-form-checkbox>
                    </td>
                    <td>{{ delivery.contract_line ? delivery.contract_line.data.contract.data.contract_no : "" }}</td>
                    <td>
                      {{ (delivery.contract_line && delivery.contract_line.data.contract_address) ? delivery.contract_line.data.contract_address.data.company_name : '' }}<br>
                      {{ (delivery.contract_line && delivery.contract_line.data.contract_address) ? delivery.contract_line.data.contract_address.data.name : '' }}
                      {{ (delivery.contract_line && delivery.contract_line.data.contract_address) ? delivery.contract_line.data.contract_address.data.last_name : '' }}<br>
                      {{ (delivery.contract_line && delivery.contract_line.data.contract_address) ? delivery.contract_line.data.contract_address.data.street : '' }}<br>
                      {{ (delivery.contract_line && delivery.contract_line.data.contract_address) ? delivery.contract_line.data.contract_address.data.zip : '' }}
                      {{ (delivery.contract_line && delivery.contract_line.data.contract_address) ? delivery.contract_line.data.contract_address.data.city : '' }}
                    </td>
                    <td v-if="product === 'reset'">
                        {{ delivery.contract_line ? delivery.contract_line.data.product_name : "" }}
                    </td>
                    <td>{{ delivery.quantity }}</td>
                    <td>{{ delivery.planned_delivery | formatDate }}</td>
                    <td class="text-right">
                        <b-button size="sm" :class="{'border': !delivery.note}" @click="editNote(index)"
                                  :variant="!delivery.note ? 'light': 'primary'">
                            <fa icon="sticky-note"/>
                        </b-button>
                        <b-button size="sm" @click="viewContract(delivery.contract_line.data.contract.data.id)" variant="primary">
                            <fa icon="eye"/>
                        </b-button>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="d-flex w-100 mt-3">
                <b-button @click.prevent="markAsDelivered()" variant="primary" :disabled="!bulkDelivery.length"
                          class="btn" :class="{'btn-loading': saving }">
                    {{$t('sandoz.mark_as_delivered')}}
                </b-button>
                <b-button @click.prevent="addBulkNote" variant="primary" :disabled="!bulkDelivery.length"
                          class="btn ml-2" :class="{'btn-loading': saving }">
                  {{$t('sandoz.mark_as_delivered_with_note')}}
                </b-button>
            </div>
            <div class="d-flex w-100 mt-3">
                <small class="text-muted float-left">{{$t('sandoz.mark_as_delivered_text_hint')}}</small>
            </div>
        </div>
        <div class="table-responsive" v-else>
            <table class="table">
                <thead>
                <tr>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="!isDate && changed">
                    <td>{{ $t('sandoz.date_error') }}</td>
                </tr>
                <tr v-else-if="!changed">
                    <td>{{ $t('sandoz.select_error_text') }}</td>
                </tr>
                <tr v-else-if="changed && !deliveries.length">
                    <td>{{ $t('sandoz.no_delivery_error_text') }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <b-modal id="modal-note" ref="modelNote" :title="$t('core.note')" @ok="saveNote()">
            <o-textarea v-model="note"></o-textarea>
        </b-modal>
        <b-modal id="modal-bulk-note" ref="modelBulkNote" :title="$t('core.note')" @ok="markAsDelivered(true)">
            <o-textarea v-model="note"></o-textarea>
        </b-modal>
    </o-card>
</template>
<script>
  import axios from 'axios'
  import qs from 'qs'

  export default {
    data: () => ({
      productList: [],
      deliveries: [],
      bulkDelivery: [],
      saving: false,
      changed: false,
      product: 'reset',
      dateList: [],
      planned_date: 'reset',
      type: [],
      productGroups: [],
      group: 'reset',
      productDistributors: [],
      distributor: 'reset',
      isDate: false,
      contractTypes: [],
      contractType: [],
      delivery: -1,
      note: null,
      toggleDelivery: true,
      contractNo: null,
      selectedType: 'reset',
      adHocItem: false,
      adhocFilter: []
    }),
    mounted() {
      this.dates()
    },
    watch: {
      adHocItem (newVal, oldVal) {
        this.dates()
      },
      contractType(newVal, oldVal) {
        this.search(this.product, this.planned_date, this.group, this.distributor)
      },
      toggleDelivery (newVal) {
        var $self = this
        if (newVal) {
          $self.deliveries.forEach(function (delivery) {
            if (!$self.bulkDelivery.includes(delivery.id)) {
              $self.bulkDelivery.push(delivery.id)
            }
          })
        } else {
          $self.bulkDelivery = []
        }
      }
    },
    methods: {
      search(product = null, date = null, group = null, distributor = null, adhoc = false) {
        let $self = this
        $self.toggleDelivery = false
        $self.bulkDelivery = []
        $self.deliveries = []
        if($self.group === 'reset' && $self.distributor === 'reset' && $self.product === 'reset') {
          $self.changed = false
          return
        } else if($self.planned_date === 'reset' && !adhoc) {
          $self.changed = true
          $self.isDate = false
          $self.deliveries = []
          return
        }

        $self.$root.$loading.start()
        if(date) {
          if(date === 'reset' && !adhoc) {
            if(!$self.planned_date) {
              $self.changed = false
              $self.deliveries = []
              $self.$root.$loading.finish()
              return
            }
          }
          $self.planned_date = date
          $self.isDate = true
        }

        if(group) {
          if(group === 'reset') {
            if(!$self.group) {
              $self.changed = false
              $self.deliveries = []
              $self.$root.$loading.finish()
              return
            }
          } else {
            $self.distributor = 'reset'
            $self.product = 'reset'
          }
          $self.changed = true
          $self.group = group
        } else if(distributor) {
          if(distributor === 'reset') {
            if(!$self.distributor) {
              $self.changed = false
              $self.deliveries = []
              $self.$root.$loading.finish()
              return
            }
          } else {
            $self.changed = true
            $self.group = 'reset'
            $self.product = 'reset'
          }
          $self.distributor = distributor
        } else if(product) {
          if(product === 'reset') {
            if(!$self.product) {
              $self.changed = false
              $self.deliveries = []
              $self.$root.$loading.finish()
              return
            }
          } else {
            $self.group = 'reset'
            $self.distributor = 'reset'
          }
          $self.changed = true
          $self.product = product
        }

        axios
          .get('/api/sandoz/contract_line_deliveries/bulk_delivery?include=contract_line,contract_line.contract,contract_line.contract_address', {
            paramsSerializer: qs.stringify,
            params: {
              'product_id': $self.product,
              'group': $self.group,
              'distributor': $self.distributor,
              'planned_date': $self.planned_date,
              'type': $self.contractType,
              'contract_no': $self.contractNo,
              'selected_type': $self.selectedType,
              'adhoc': $self.adHocItem
            }
          })
          .then((response) => {
            $self.deliveries = response.data.data
            $self.deliveries.forEach(function (delivery) {
              $self.bulkDelivery.push(delivery.id)
            })
            $self.toggleDelivery = true
            $self.$root.$loading.finish()
          })
          .catch((error) => {
            $self.$root.$loading.finish()
            console.log(error)
          })
      },
      markAsDelivered(withNote = false) {
        let $self = this
        let url = '/api/sandoz/contract_line_deliveries/mark_as_delivered?include=contract_line,contract_line.contract'
        $self.saving = true

        axios
          .post(url, {
            'product_id': $self.product,
            'group': $self.group,
            'distributor': $self.distributor,
            'planned_date': $self.planned_date,
            'type': $self.contractType,
            'contract_no': $self.contractNo,
            'selected_type': $self.selectedType,
            'deliveries': $self.bulkDelivery,
            'with_note': withNote,
            'note': withNote ? $self.note : null
          })
          .then((response) => {
            $self.deliveries = response.data.data
            $self.bulkDelivery = []
            $self.saving = false
            if (withNote) {
              $self.note = null
              $self.$refs.modelBulkNote.hide()
            }
            $self.$notify({
              title: $self.$i18n.t('core.saved'),
              text: $self.$i18n.t('core.saved_text')
            })
          })
          .catch((error) => {
            $self.saving = false
            if (withNote) {
              $self.note = null
              $self.$refs.modelBulkNote.hide()
            }
            $self.$notify({
              title: $self.$i18n.t('core.save_error'),
              text: $self.$i18n.t('core.save_error_text', {url: url}),
              type: 'error'
            })
          })
      },
      filters(type) {
        this.selectedType = type
        this.products(type)
        this.groups(type)
        this.distributors(type)
      },
      products(type) {
        if(type === 'reset') {
            this.productList = []
            this.deliveries = []
            this.bulkDelivery = []
            this.toggleDelivery = false
            return
        }

        axios.get('/api/sandoz/contract_line_deliveries/products/'+type+'?per_page=' + Number.MAX_SAFE_INTEGER).then((response) => {
          this.productList = response.data.data
          this.productList.unshift({id : 'reset', name_lang: this.$t('sandoz.select') + ' ' + this.$t('sandoz.product')})
          this.deliveries = []
          this.bulkDelivery = []
          this.toggleDelivery = false
        }).catch((error) => {
          console.error(error)
        })

      },
      groups(type) {
        if(type === 'reset') {
            this.productGroups = []
            this.deliveries = []
            this.bulkDelivery = []
            this.toggleDelivery = false
            return
        }

        axios.get('/api/sandoz/contract_line_deliveries/groups/'+type).then((response) => {
            this.productGroups = response.data
            this.productGroups.unshift({value : 'reset', product_group: this.$t('sandoz.select') + ' ' + this.$t('sandoz.product_group')})
            this.deliveries = []
            this.bulkDelivery = []
            this.toggleDelivery = false
        }).catch((error) => {
            console.error(error)
        })
      },
      distributors(type) {
        if(type === 'reset') {
          this.productDistributors = []
          this.deliveries = []
          this.bulkDelivery = []
          this.toggleDelivery = false
          return
        }

        axios.get('/api/sandoz/contract_line_deliveries/distributors/'+type).then((response) => {
          this.productDistributors = response.data
          this.productDistributors.unshift(
            {value : 'reset', distributor: this.$t('sandoz.select') + ' ' + this.$t('sandoz.distributor')},
            {value : 'all', distributor: this.$t('sandoz.all_distributors')},
            {value : 'empty', distributor: this.$t('sandoz.empty_distributor')},
          )
          this.deliveries = []
          this.bulkDelivery = []
          this.toggleDelivery = false
        }).catch((error) => {
          console.error(error)
        })
      },
      editNote (delivery) {
        this.$refs.modelNote.show()
        this.delivery = delivery
        this.note = this.deliveries[delivery].note
      },
      addBulkNote () {
        this.$refs.modelBulkNote.show()
        this.note = null
      },
      saveNote () {
        const $self = this
        const id = $self.deliveries[$self.delivery].id
        const url = '/api/sandoz/contract_line_deliveries/' + id
        $self.saving = true

        axios
            .post(url, {
              'id': id,
              'note': $self.note
            })
            .then((response) => {
              $self.saving = false
              $self.deliveries[$self.delivery].note = $self.note
              $self.delivery = -1
              $self.note = null
              $self.$refs.modelNote.hide()
              $self.$notify({
                title: $self.$i18n.t('core.saved'),
                text: $self.$i18n.t('core.saved_text')
              })
            })
            .catch((error) => {
              $self.saving = false
              $self.$notify({
                title: $self.$i18n.t('core.save_error'),
                text: $self.$i18n.t('core.save_error_text', { url: url }),
                type: 'error'
              })
            })
      },
      viewContract (id) {
        const routeData = this.$router.resolve({ path: '/sandoz/contracts/view/' + id })
        window.open(routeData.href, '_blank')
      },
      dates () {
        this.dateList = []
        axios.get('/api/sandoz/contract_line_deliveries/date/false/' + this.adHocItem).then((response) => {
          this.dateList = response.data.planned_delivery
          this.dateList.forEach((item, index) => {
            this.dateList[index].planned_delivery = this.$options.filters.formatDate(item.date)
          })
          this.dateList.unshift({date : 'reset', planned_delivery: this.$t('sandoz.select') +' '+ this.$t('sandoz.date')})
        }).catch((error) => {
          console.error(error)
        })
      },
    },
    created() {
      this.type = [
          {value: 'reset', text: this.$t('sandoz.select') + ' ' + this.$t('sandoz.product_type')},
          {value: 'service', text: this.$i18n.t('sandoz.service')},
          {value: 'marketing_activity', text: this.$i18n.t('sandoz.marketing_activity')}
      ]
      this.contractTypes = [
        {value: 'APO', text: this.$i18n.t('sandoz.apo')},
        {value: 'APO_ONE', text: this.$i18n.t('sandoz.apo_one')},
        {value: 'SD', text: this.$i18n.t('sandoz.sd')},
        {value: 'CNS', text: this.$i18n.t('sandoz.cns')},
        {value: 'HEIM', text: this.$i18n.t('sandoz.heim')},
        {value: 'IMMUNO', text: this.$i18n.t('sandoz.immuno')},
        {value: 'ONCO', text: this.$i18n.t('sandoz.onco')},
        {value: 'KAM_APO', text: this.$i18n.t('sandoz.kam_apo')},
        {value: 'KAM_SD', text: this.$i18n.t('sandoz.kam_sd')},
        {value: 'KAM_HOSP', text: this.$i18n.t('sandoz.kam_hosp')},
        {value: 'KAM_WHS', text: this.$i18n.t('sandoz.kam_whs')},
        {value: 'OTC', text: this.$i18n.t('sandoz.otc')},
        {value: 'APO_OTC', text: this.$i18n.t('sandoz.apo_otc')},
        {value: 'SD_GADGET', text: this.$i18n.t('sandoz.sd_gadget')},
        {value: 'CNS_GADGET', text: this.$i18n.t('sandoz.cns_gadget')},
        /*{value: 'ONCO_GADGET', text: this.$i18n.t('sandoz.onco_gadget')},*/
        {value: 'IMMUNO_GADGET', text: this.$i18n.t('sandoz.immuno_gadget')},
        {value: 'KAM_SD_GADGET', text: this.$i18n.t('sandoz.kam_sd_gadget')},
        {value: 'APO_GADGET', text: this.$i18n.t('sandoz.apo_gadget')},
        {value: 'KAM_APO_GADGET', text: this.$i18n.t('sandoz.kam_apo_gadget')},
        {value: 'PV', text: this.$i18n.t('sandoz.pv')},
        {value: 'BIOS_APO', text: this.$i18n.t('sandoz.bios_apo')},
        {value: 'HIGHSPEC_GADGET', text: this.$i18n.t('sandoz.highspec_gadget')},
        {value: 'BIOS_KAM_APO', text: this.$i18n.t('sandoz.bios_kam_apo')},
        {value: 'BIOS_KAM_WHS', text: this.$i18n.t('sandoz.bios_kam_whs')},
        {value: 'APO_KUKO', text: this.$i18n.t('sandoz.apo_kuko')},
        {value: 'SD_KUKO', text: this.$i18n.t('sandoz.sd_kuko')},
        {value: 'IMMUNO_KUKO', text: this.$i18n.t('sandoz.immuno_kuko')},
        {value: 'HOSP_KUKO', text: this.$i18n.t('sandoz.hosp_kuko')},
        {value: 'CNS_KUKO', text: this.$i18n.t('sandoz.cns_kuko')},
      ]

      this.adhocFilter = [
        {value: true, text: this.$i18n.t('sandoz.yes')},
        {value: false, text: this.$i18n.t('sandoz.no')}
      ]
    }
  }
</script>
